let skModalMixin = {
    methods: {
      opened() {},
      closed() {},
      handleOptions(options) {},
      open(options) {
        this.handleOptions(options ? options : {})
        $(this.$refs.modal).modal("show")
        this.opened()
      },
      close() {
        $(this.$refs.modal).modal("hide")
        this.closed()
      }
    }
  }
  
  export default skModalMixin